import type { Object3D } from 'three'

export default function useAR() {
  const arMode = ref<(typeof ARMode)[keyof typeof ARMode]>(ARMode.NONE)

  const arModes = ['scene-viewer', 'quick-look']

  async function selectARMode() {
    for (const value of arModes) {
      if (
        value === 'scene-viewer' &&
        (IS_SCENEVIEWER_CANDIDATE ||
          ((navigator as any).userAgentData &&
            (navigator as any).userAgentData.getHighEntropyValues &&
            (await (navigator as any).userAgentData
              .getHighEntropyValues(['formFactor'])
              .formFactor?.includes('XR'))))
      ) {
        arMode.value = ARMode.SCENE_VIEWER
        break
      }
      if (value === 'quick-look' && IS_AR_QUICKLOOK_CANDIDATE) {
        arMode.value = ARMode.QUICK_LOOK
        break
      }
      // The presence of ios-src overrides the absence of quick-look
      // ar-mode.
      if (arMode.value === ARMode.NONE && IS_AR_QUICKLOOK_CANDIDATE) {
        arMode.value = ARMode.QUICK_LOOK
      }
    }
  }

  async function activateAR(model: Object3D) {
    switch (arMode.value) {
      case ARMode.QUICK_LOOK:
        await openIOSARQuickLook(model)
        break
      case ARMode.SCENE_VIEWER:
        openSceneViewerDynamic(model)
        break
      default:
        console.warn(
          'No AR Mode can be activated. This is probably due to missing \
  configuration or device capabilities'
        )
        break
    }
  }

  return {
    arMode,
    selectARMode,
    activateAR,
  }
}
